import axios from "axios";
import { API_URL } from "../config/axiosConfig";

export const apiGetTransactionByDate = (token, date) =>
  axios.get(`${API_URL}/v1/transaction/date/${date}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetTransactionToday = (token) =>
  axios.get(`${API_URL}/v1/transaction/date/today`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
